import React from 'react';
import { copyFor } from 'config';
import { VnmTerms } from 'components/modals/vnm-terms';
import { useFunnelRedirect } from 'hooks/use-funnel-redirect.hook';
import type { MappedContractSubscriberRequirement } from 'hooks/use-contract-requirements.hook';

const getCopy = copyFor('settings.contractAgreements');

interface SignTermsModalProps {
  incompleteRequirements: MappedContractSubscriberRequirement[];
  userId: number;
  onSubmit: () => Promise<any>;
  onClose: () => void;
  redirect?: ReturnType<typeof useFunnelRedirect>[0];
}

export const SignTermsModal = ({
  incompleteRequirements,
  userId,
  onClose,
  onSubmit,
  redirect,
}: SignTermsModalProps) => {
  const submit = async () => {
    await onSubmit();
    if (redirect) {
      redirect();
    }
  };
  return (
    <VnmTerms
      incompleteRequirements={incompleteRequirements}
      userId={userId}
      title={getCopy('signTerms')}
      onClose={onClose}
      onSubmit={submit}
    />
  );
};
